export default {
    computed: {
        
        getTargetType () {
            return [
                {
                    label: "销售目标",
                    value: 0
                },
                {
                    label: "利润目标",
                    value: 1
                }
            ];
        },
        getBussinessType () {
            return [
                {
                    label: "amazon_1p",
                    value: 0
                },
                {
                    label: "amazon_3p",
                    value: 1
                },
                {
                    label: "wayfair",
                    value: 2
                },
                {
                    label: "homedepot",
                    value: 3
                },
                {
                    label: "others",
                    value: 4
                }
            ];
        },
    }
};